export default [
	{
		path: "/pros",
		exact: true,
		policy: "providerAuth",
		component: "Home",
		mui: true,
	},
];
